import _defineProperty from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { withRouter, matchPath } from 'react-router';
import { generateUniqueId } from '../utils';
import { IonBackButtonInner, IonRouterOutletInner } from '../index';
import IonPage from '../IonPage';
var Context = React.createContext({
  goBack: function goBack() {}
});

var RouterOutlet =
/*#__PURE__*/
function (_Component) {
  _inherits(RouterOutlet, _Component);

  function RouterOutlet(props) {
    var _this;

    _classCallCheck(this, RouterOutlet);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RouterOutlet).call(this, props));
    _this.enteringEl = React.createRef();
    _this.leavingEl = React.createRef();
    _this.containerEl = React.createRef();

    _this.goBack = function () {
      var prevView = _this.state.views.find(function (v) {
        return v.id === _this.state.activeId;
      });

      var newView = _this.state.views.find(function (v) {
        return v.id === prevView.prevId;
      });

      _this.props.history.replace(newView.location.pathname);
    };

    _this.state = {
      direction: undefined,
      inTransition: false,
      activeId: undefined,
      prevActiveId: undefined,
      tabActiveIds: {},
      views: []
    };
    return _this;
  }

  _createClass(RouterOutlet, [{
    key: "renderChild",
    value: function renderChild(item) {
      return React.cloneElement(item.element, {
        location: item.location,
        computedMatch: item.match
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var enteringEl = this.enteringEl.current != null ? this.enteringEl.current : undefined;
      var leavingEl = this.leavingEl.current != null ? this.leavingEl.current : undefined;

      if (this.state.direction && !this.state.inTransition) {
        this.setState({
          inTransition: true
        });
        this.containerEl.current.commit(enteringEl, leavingEl, {
          deepWait: true,
          duration: this.state.direction === undefined ? 0 : undefined,
          direction: this.state.direction,
          showGoBack: true,
          progressAnimation: false
        }).then(function () {
          _this2.setState(function () {
            return {
              inTransition: false,
              direction: undefined
            };
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement(IonRouterOutletInner, {
        ref: this.containerEl
      }, React.createElement(Context.Provider, {
        value: {
          goBack: this.goBack
        }
      }, this.state.views.map(function (item) {
        var props = {};

        if (item.id === _this3.state.prevActiveId) {
          props = {
            'ref': _this3.leavingEl,
            'hidden': _this3.state.direction == null,
            'className': _this3.state.direction == null ? ' ion-page-hidden' : ''
          };
        } else if (item.id === _this3.state.activeId) {
          props = {
            'ref': _this3.enteringEl,
            'className': _this3.state.direction != null ? ' ion-page-invisible' : ''
          };
        } else {
          props = {
            'aria-hidden': true,
            'className': 'ion-page-hidden'
          };
        }

        return React.createElement(IonPage, Object.assign({}, props, {
          key: item.id
        }), _this3.renderChild(item));
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var location = props.location;
      var match = null;
      var element;
      /**
       * Get the current active view and if the path is the same then do nothing
       */

      var activeView = state.views.find(function (v) {
        return v.id === state.activeId;
      });
      /**
       * Look at all available paths and find the one that matches
       */

      React.Children.forEach(props.children, function (child) {
        if (match == null) {
          element = child;
          match = matchPath(location.pathname, child.props);
        }
      });
      /**
       * If there are no matches then set the active view to null and exit
       */

      if (!match) {
        return {
          direction: undefined,
          activeId: undefined,
          prevActiveId: undefined
        };
      }
      /**
       * Get the active view for the tab that matches.
       * If the location matches the existing tab path then set that view as active
       */


      var id = state.tabActiveIds[match.params.tab];
      var currentActiveTabView = state.views.find(function (v) {
        return v.id === id;
      });

      if (currentActiveTabView && currentActiveTabView.location.pathname === props.location.pathname) {
        if (currentActiveTabView.id === state.activeId) {
          return null;
        }

        return {
          direction: undefined,
          activeId: currentActiveTabView.id,
          prevActiveId: undefined
        };
      }
      /**
       * If the new active view is a previous view
       */


      if (activeView) {
        var prevActiveView = state.views.find(function (v) {
          return v.id === activeView.prevId;
        });

        if (prevActiveView && activeView.match.params.tab === match.params.tab && prevActiveView.match.url === match.url) {
          return {
            direction: 'back',
            activeId: prevActiveView.id,
            prevActiveId: activeView.id,
            tabActiveIds: Object.assign({}, state.tabActiveIds, _defineProperty({}, match.params.tab, prevActiveView.id))
          };
        }
      }

      var viewId = generateUniqueId();
      return {
        direction: state.tabActiveIds[match.params.tab] ? 'forward' : undefined,
        activeId: viewId,
        prevActiveId: state.tabActiveIds[match.params.tab],
        tabActiveIds: Object.assign({}, state.tabActiveIds, _defineProperty({}, match.params.tab, viewId)),
        views: state.views.concat({
          id: viewId,
          location: location,
          match: match,
          element: element,
          prevId: state.tabActiveIds[match.params.tab]
        })
      };
    }
  }]);

  return RouterOutlet;
}(Component);

export var IonRouterOutlet = withRouter(RouterOutlet);
export var IonBackButton =
/*#__PURE__*/
function (_Component2) {
  _inherits(IonBackButton, _Component2);

  function IonBackButton() {
    var _this4;

    _classCallCheck(this, IonBackButton);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(IonBackButton).apply(this, arguments));

    _this4.clickButton = function (e) {
      e.stopPropagation();

      _this4.context.goBack();
    };

    return _this4;
  }

  _createClass(IonBackButton, [{
    key: "render",
    value: function render() {
      return React.createElement(IonBackButtonInner, Object.assign({
        onClick: this.clickButton
      }, this.props));
    }
  }]);

  return IonBackButton;
}(Component);
IonBackButton.contextType = Context;